import {Component, inject, viewChild} from '@angular/core';
import {
  FormGroup,
  FormGroupDirective,
  NonNullableFormBuilder,
  ReactiveFormsModule,
  Validators
} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatButton} from "@angular/material/button";
import {ContactStore} from "../store/contact-store";
import {ContactSubmissionPayload} from "../../../../../core/data/contact/contact-api";
import {signalMethod} from "@ngrx/signals";
import {ValidationMessagesConstant} from "../../../../../core/constants/validation-messages.constant";

@Component({
  selector: 'app-feedback-form',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInput,
    MatButton
  ],
  templateUrl: './feedback-form.component.html',
  styleUrl: './feedback-form.component.scss',
  standalone: true,
  providers: [ContactStore]
})
export class FeedbackFormComponent {

  readonly #store = inject(ContactStore);
  readonly #fb = inject(NonNullableFormBuilder);
  readonly formDirective = viewChild(FormGroupDirective);

  protected readonly isLoading = this.#store.isLoading;
  protected readonly error = this.#store.error;
  protected readonly form = this.#fb.group({
    fullname: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    phone: [''],
    message: ['', Validators.required]
  });

  constructor() {
    this.#resetAfterSuccess(this.#store.lastSubmittedAt);
  }

  getControl(name: string): FormGroup {
    return this.form.get(name) as FormGroup;
  }

  hasError(name: string, error: string) {
    var e = this.getControl(name);
    return e && (e.dirty || e.touched) && e.hasError(error);
  }

  protected submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const value = this.form.getRawValue();
    const payload: ContactSubmissionPayload = { ...value };

    this.#store.submit(payload);
  }

  readonly #resetAfterSuccess = signalMethod<number | null>((timestamp) => {
    if (!timestamp) {
      return;
    }

    this.formDirective()?.resetForm();
  });

  protected readonly ValidationMessagesConstant = ValidationMessagesConstant;
}
